import { createStore } from "vuex";
import { sharedModule } from "search-observe-app";
import packageJson from "../../package.json";

const store = createStore({
  modules: {
    shared: sharedModule,
    app: {
      namespaced: true,
      state: () => ({
        pkg: packageJson,
        siteUrl: "https://at-sea-downed-bird.abrinc.com",
        incidental: true,
        refTables: {
          ref_lighting: [],
          ref_observer: [],
          ref_fatality_injury: [],
          ref_age: [],
          ref_sex: [],
          ref_observer_type: [],
          ref_precipitation: [],
          ref_wind_direction: [],
          ref_wind_speed: [],
          ref_bird_species: [],
          ref_photo_type: [],
          ref_breadcrumb_location: [],
          ref_structure_type: [],
          ref_vessel: [],
        },
        dataTables: {
          survey_effort: [],
          survey_breadcrumb: [],
          survey_downed_bird: [],
          survey_photo_downed_bird: [],
        },
        tablePositions: {
          survey_effort: -1,
          survey_breadcrumb: -1,
          survey_downed_bird: -1,
          survey_photo_downed_bird: -1,
        },
        views: {
          recent_survey_effort: [],
          recent_survey_downed_bird: [],
          recent_survey_predator: [],
        },
      }),
      getters: {},
      mutations: {},
    },
  },
});
export default store;
